module.exports = __webpack_public_path__ + "static/media/KEYFI-BNB.fc80be91.svg";